/**
 * Typed API client for the mobile device registry (My Devices) — Epic 225.
 *
 * Per-user push-token registration for iOS/Android/web/desktop clients.
 * Mirrors internal/mobiledevices.
 */

import { apiClient } from '@/lib/apiClient';

export type DevicePlatform = 'ios' | 'android' | 'web' | 'desktop';

export interface Device {
  id: string;
  platform: DevicePlatform;
  appVersion: string | null;
  lastSeenAt: string;
  createdAt: string;
}

export async function listDevices(): Promise<Device[]> {
  const { data } = await apiClient.get<Device[]>('/mobile/devices');
  return data;
}

export interface RegisterDeviceRequest {
  platform: DevicePlatform;
  pushToken: string;
  appVersion?: string;
}

export async function registerDevice(req: RegisterDeviceRequest): Promise<{ id: string }> {
  const { data } = await apiClient.post<{ id: string }>('/mobile/devices', req);
  return data;
}

export async function unregisterDevice(id: string): Promise<void> {
  await apiClient.delete(`/mobile/devices/${id}`);
}
